/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabView, TabPanel } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// @mui material components
import Grid from "@mui/material/Grid";

// Layouts
import Department from "./department";
import UserRoles from "./user-roles";
import UserDetails from "./user-details";

import { getSubModulesByRoleId } from "../../store";

import Cookies from "universal-cookie";
// import ViewAccess from "./ViewAccess";
// import ClientRoles from "./client-roles";
import Components from "./components";
import ClientRoles from "layouts/admin-management/client-roles";
import ClientDetails from "layouts/admin-management/client-details";
import ViewAccess from "./view-access/index";
// import ClientDetails from "./client-details";

const cookies = new Cookies();

const UserManagement = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let roleName = loginDetails.data.roleName;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : []
    );
  }, [getSubModulesByRoleIdReducer]);

  let departmentModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "52d9a4db-a3eb-4914-a623-f8cb1ae643fe"
  );

  let userRolesModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "428d1fae-c385-4576-8e00-77c60ec81ff2"
  );

  let userDetailsModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "8820f59d-7f44-4ddb-b251-d246cccc726b"
  );

  let viewAccessModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "df578bce-0f64-49c4-ab61-7be2d2d942bb"
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {departmentModule &&
            userRolesModule &&
            userDetailsModule &&
            viewAccessModule ? (
              <TabView>
                <TabPanel header="Department">
                  <Department />
                </TabPanel>
                <TabPanel header="User Roles">
                  <ClientRoles />
                </TabPanel>
                <TabPanel header="User Details">
                  <ClientDetails />
                </TabPanel>
                <TabPanel header="View Access">
                  <ViewAccess />
                </TabPanel>
              </TabView>
            ) : !departmentModule &&
              userRolesModule &&
              userDetailsModule &&
              viewAccessModule ? (
              <TabView>
                <TabPanel header="User Roles">
                  <ClientRoles />
                </TabPanel>
                <TabPanel header="User Details">
                  <ClientDetails />
                </TabPanel>
                <TabPanel header="View Access">
                  <ViewAccess />
                </TabPanel>
              </TabView>
            ) : departmentModule &&
              !userRolesModule &&
              userDetailsModule &&
              viewAccessModule ? (
              <TabView>
                <TabPanel header="Department">
                  <Department />
                </TabPanel>
                <TabPanel header="User Details">
                  <ClientDetails />
                </TabPanel>
                <TabPanel header="View Access">
                  <ViewAccess />
                </TabPanel>
              </TabView>
            ) : departmentModule &&
              userRolesModule &&
              !userDetailsModule &&
              viewAccessModule ? (
              <TabView>
                <TabPanel header="Department">
                  <Department />
                </TabPanel>
                <TabPanel header="User Roles">
                  <ClientRoles />
                </TabPanel>
                <TabPanel header="View Access">
                  <ViewAccess />
                </TabPanel>
              </TabView>
            ) : departmentModule &&
              userRolesModule &&
              userDetailsModule &&
              !viewAccessModule ? (
              <TabView>
                <TabPanel header="Department">
                  <Department />
                </TabPanel>
                <TabPanel header="User Roles">
                  <ClientRoles />
                </TabPanel>
                <TabPanel header="User Details">
                  <ClientDetails />
                </TabPanel>
              </TabView>
            ) : !departmentModule &&
              !userRolesModule &&
              userDetailsModule &&
              viewAccessModule ? (
              <TabView>
                <TabPanel header="User Details">
                  <ClientDetails />
                </TabPanel>
                <TabPanel header="View Access">
                  <ViewAccess />
                </TabPanel>
              </TabView>
            ) : departmentModule &&
              !userRolesModule &&
              !userDetailsModule &&
              viewAccessModule ? (
              <TabView>
                <TabPanel header="Department">
                  <Department />
                </TabPanel>
                <TabPanel header="View Access">
                  <ViewAccess />
                </TabPanel>
              </TabView>
            ) : departmentModule &&
              userRolesModule &&
              !userDetailsModule &&
              !viewAccessModule ? (
              <TabView>
                <TabPanel header="Department">
                  <Department />
                </TabPanel>
                <TabPanel header="User Roles">
                  <ClientRoles />
                </TabPanel>
              </TabView>
            ) : !departmentModule &&
              userRolesModule &&
              !userDetailsModule &&
              viewAccessModule ? (
              <TabView>
                <TabPanel header="User Roles">
                  <ClientRoles />
                </TabPanel>
                <TabPanel header="View Access">
                  <ViewAccess />
                </TabPanel>
              </TabView>
            ) : !departmentModule &&
              userRolesModule &&
              userDetailsModule &&
              !viewAccessModule ? (
              <TabView>
                <TabPanel header="User Roles">
                  <ClientRoles />
                </TabPanel>
                <TabPanel header="User Details">
                  <ClientDetails />
                </TabPanel>
              </TabView>
            ) : !departmentModule &&
              !userRolesModule &&
              !userDetailsModule &&
              viewAccessModule ? (
              <TabView>
                <TabPanel header="View Access">
                  <ViewAccess />
                </TabPanel>
              </TabView>
            ) : departmentModule &&
              !userRolesModule &&
              !userDetailsModule &&
              !viewAccessModule ? (
              <TabView>
                <TabPanel header="Department">
                  <Department />
                </TabPanel>
              </TabView>
            ) : departmentModule &&
              !userRolesModule &&
              userDetailsModule &&
              !viewAccessModule ? (
              <TabView>
                <TabPanel header="Department">
                  <Department />
                </TabPanel>
                <TabPanel header="User Details">
                  <ClientDetails />
                </TabPanel>
              </TabView>
            ) : !departmentModule &&
              userRolesModule &&
              !userDetailsModule &&
              !viewAccessModule ? (
              <TabView>
                <TabPanel header="User Roles">
                  <ClientRoles />
                </TabPanel>
              </TabView>
            ) : !departmentModule &&
              !userRolesModule &&
              userDetailsModule &&
              !viewAccessModule ? (
              <TabView>
                <TabPanel header="User Details">
                  <ClientDetails />
                </TabPanel>
              </TabView>
            ) : !departmentModule &&
              !userRolesModule &&
              !userDetailsModule &&
              !viewAccessModule ? (
              <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                No User Management Access
              </h4>
            ) : null}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(UserManagement);
